import React from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  MenuItem
} from "@mui/material";
import { sharedStyles } from '../styles/sharedStyles';

const streetTypes = [
  { value: "", label: "Please select Street Type" },
  { value: "STR", label: "STREET" },
  { value: "LN", label: "LANE" },
  { value: "BLV", label: "BOULEVARD" },
  { value: "AVE", label: "AVENUE" },
  { value: "RD", label: "ROAD" },
  { value: "DRV", label: "DRIVE" },
  { value: "CRS", label: "CRESCENT" }
];

const Step3MedicalInfo = ({ formData, setFormData, errors = {}, setErrors, handleNext, handleBack }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (e) => {
    const mapping = {
      cellphone: 'm_cell',
      email: 'm_email',
      taxNumber: 'mtax',
      homeNumber: 'm_telh',
      workNumber: 'm_telw',
      alternateEmail: 'm_altemail',
      preferredCommunication: 'm_comm_method',
      poBoxNumber: 'mainid_pobox',
      unitNumber: 'unit_num',
      complexName: 'complex_name',
      streetNumber: 'm_psnum',
      streetName: 'm_psname',
      streetType: 'm_pstype',
      suburb: 'm_psuburb',
      postalCode: 'm_postalcode',
      poBoxSuburb: 'm_psuburb',
      poBoxPostalCode: 'm_postalcode',
      ssnum: 'm_ssnum',
      ssname: 'm_ssname',
      sstype: 'm_sstype',
      ssuburb: 'm_ssuburb',
      spostalcode: 'm_spostalcode',
      employername: 'employername',
      employeenum: 'employeenum',
      empdate: 'empdate',
      department: 'department',
      stowncode: 'm_stowncode',
      towncode: 'm_towncode',
    };
    const { name, value } = e.target;
    if (name === 'isPOBox') {
      setFormData({ ...formData, isPOBox: value });
      setErrors({ ...errors, isPOBox: undefined });
    } else {
      const apiKey = mapping[name] || name;
      const contacts = Array.isArray(formData.members_contacts) && formData.members_contacts.length > 0
        ? [...formData.members_contacts]
        : [{}];
      contacts[0] = { ...contacts[0], [apiKey]: value };
      setFormData({ ...formData, members_contacts: contacts });
      setErrors({ ...errors, [apiKey]: undefined });
    }
  };

  const validate = () => {
    return true;
  };

  const onNext = (e) => {
    e.preventDefault();
    if (validate()) handleNext();
  };

  const contacts = Array.isArray(formData.members_contacts) && formData.members_contacts.length > 0 ? formData.members_contacts[0] : {};
  const showPostalAddress = contacts.m_comm_method === "Post";
  const isPOBox = formData.isPOBox === "Yes";

  return (
    <Box component="form" onSubmit={onNext} autoComplete="off" sx={sharedStyles.formContainer}>
      <Typography variant="h5" sx={sharedStyles.stepTitle}>
        Contact & Tax Information
      </Typography>
      <Paper sx={sharedStyles.card}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Tax Number"
              name="taxNumber"
              value={contacts.mtax || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.mtax}
              helperText={errors.mtax}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Cellphone"
              name="cellphone"
              type="tel"
              value={contacts.m_cell || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.m_cell}
              helperText={errors.m_cell}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Tel (W) (Work Number)"
              name="workNumber"
              type="tel"
              value={contacts.m_telw || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.m_telw}
              helperText={errors.m_telw}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Tel (H) (Home Number)"
              name="homeNumber"
              type="tel"
              value={contacts.m_telh || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.m_telh}
              helperText={errors.m_telh}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              name="email"
              type="email"
              value={contacts.m_email || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.m_email}
              helperText={errors.m_email}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Alternate Email"
              name="alternateEmail"
              type="email"
              value={contacts.m_altemail || ""}
              onChange={handleChange}
              fullWidth
              {...sharedStyles.inputProps}
              error={!!errors.m_altemail}
              helperText={errors.m_altemail}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ mb: 1, fontWeight: 500 }}>Preferred Method of Communication</Typography>
            <RadioGroup
              row
              name="preferredCommunication"
              value={contacts.m_comm_method || ""}
              onChange={handleChange}
            >
              <FormControlLabel value="Email" control={<Radio color="primary" />} label="Email" />
              <FormControlLabel value="Post" control={<Radio color="primary" />} label="Post" />
            </RadioGroup>
          </Grid>
          <Grid item xs={12} sm={6} />

          {showPostalAddress && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  label="Is This a PO Box"
                  name="isPOBox"
                  value={formData.isPOBox || ""}
                  onChange={handleChange}
                  fullWidth
                  {...sharedStyles.inputProps}
                  error={!!errors.isPOBox}
                  helperText={errors.isPOBox}
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} />

              {isPOBox ? (
                // PO Box Address Fields
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="P.O. Box Number"
                      name="poBoxNumber"
                      value={contacts.mainid_pobox || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.mainid_pobox}
                      helperText={errors.mainid_pobox}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Suburb"
                      name="poBoxSuburb"
                      value={contacts.m_psuburb || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_psuburb}
                      helperText={errors.m_psuburb}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Postal Code"
                      name="poBoxPostalCode"
                      value={contacts.m_postalcode || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_postalcode}
                      helperText={errors.m_postalcode}
                    />
                  </Grid>
                </>
              ) : (
                // Physical Address Fields
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Unit Number"
                      name="unitNumber"
                      value={contacts.unit_num || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.unit_num}
                      helperText={errors.unit_num}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Complex Name"
                      name="complexName"
                      value={contacts.complex_name || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.complex_name}
                      helperText={errors.complex_name}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Street Number"
                      name="streetNumber"
                      value={contacts.m_psnum || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_psnum}
                      helperText={errors.m_psnum}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Street Name"
                      name="streetName"
                      value={contacts.m_psname || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_psname}
                      helperText={errors.m_psname}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      label="Street Type"
                      name="streetType"
                      value={contacts.m_pstype || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_pstype}
                      helperText={errors.m_pstype}
                    >
                      {streetTypes.map((type) => (
                        <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Suburb"
                      name="suburb"
                      value={contacts.m_psuburb || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_psuburb}
                      helperText={errors.m_psuburb}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Postal Code"
                      name="postalCode"
                      value={contacts.m_postalcode || ""}
                      onChange={handleChange}
                      fullWidth
                      {...sharedStyles.inputProps}
                      error={!!errors.m_postalcode}
                      helperText={errors.m_postalcode}
                    />
                  </Grid>
                </>
              )}
            </>
          )}
        </Grid>
      </Paper>
    </Box>
  );
};

export default Step3MedicalInfo; 